import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { IFlight } from "@/feature/flight/search/types/flight";
import { TFlightSearchFormData } from "@/feature/flight/search/types/search";


interface ISelectFlight {
  expireTime?: string;
  data?: IFlight[];
  searchId?: string | null;
}

interface IFlightDataState {
  searchFormData: TFlightSearchFormData;
  selectFlight: ISelectFlight;
}

const initialState: IFlightDataState = {
  searchFormData: {
    tripType: "oneway",
    fareType: "regularFare",
    passengers: {
      adults: 1,
      children: 0,
      infants: 0,
    },
    childrenAges: [],
    cabin: "1",
    flights: [],
    preferredAirlines: undefined,
  },
  selectFlight: {
    searchId: null,
    expireTime: undefined,
    data: undefined,
  },
};

const flightData = createSlice({
  name: "flightData",
  initialState,
  reducers: {
    setSelectedFlight: (state, action: PayloadAction<ISelectFlight>) => {
      const incoming = action.payload;
      const searchId = incoming.searchId;
      const expTime = incoming.expireTime;
      if (!expTime && state.selectFlight.expireTime) {
        state.selectFlight.expireTime = state.selectFlight.expireTime;
      } else if (expTime) {
        const parsed = Number(expTime);
        state.selectFlight.expireTime =
          Number.isFinite(parsed) && parsed > Date.now() ? expTime : undefined;
      }
      state.selectFlight.data = incoming.data ?? state.selectFlight.data;
      state.selectFlight.searchId = searchId ?? state.selectFlight.searchId;
    },
    removeSelectedFlightByID: (state, action: PayloadAction<string>) => {
      state.selectFlight = {
        ...state.selectFlight,
        data: state.selectFlight.data?.filter(
          (flight) => flight.flight_id !== action.payload,
        ),
      };
    },
    resetSelectedFlight: (state) => {
      state.selectFlight = initialState.selectFlight;
    },
    setFlightFormData: (state, action: PayloadAction<TFlightSearchFormData>) => {
      state.searchFormData = action.payload;
    },
  },
});

export const {
  setFlightFormData,
  setSelectedFlight,
  removeSelectedFlightByID,
  resetSelectedFlight,
} = flightData.actions;

export default flightData;




